import React, { useEffect, useState } from "react";
import {
  FaChartLine,
  FaClipboardList,
  FaExchangeAlt,
  FaHistory,
  FaPlus,
  FaReceipt,
  FaShoppingCart,
  FaSignOutAlt,
  FaBars,
} from "react-icons/fa";
import { Menu, MenuItem, Sidebar as ProSidebar } from "react-pro-sidebar";
import { useNavigate } from "react-router-dom";
import logo from "../../Images/buillogo6.png";

const Sidebar = ({ setCurrentPage, currentPage, collapsed, setCollapsed }) => {
  const navigate = useNavigate();
  const [isMobile, setIsMobile] = useState(false);
  const [toggled, setToggled] = useState(false);

  useEffect(() => {
    const mq = window.matchMedia("(max-width: 640px)");
    const onChange = () => setIsMobile(mq.matches);
    onChange();
    mq.addEventListener("change", onChange);
    return () => mq.removeEventListener("change", onChange);
  }, []);

  const handleSignOut = () => {
    localStorage.clear();
    navigate("/");
  };

  const handleMenuClick = (page) => {
    setCurrentPage(page);
    if (isMobile) setToggled(false);
  };

  return (
    <div className="text-gray-200 max-h-screen overflow-auto">
      {isMobile && !toggled && (
        <button
          onClick={() => setToggled(true)}
          className="fixed top-4 left-4 z-[9999] text-gray-100 text-2xl"
          aria-label="Open sidebar"
        >
          <FaBars />
        </button>
      )}

      <ProSidebar
        collapsed={!isMobile && collapsed}
        toggled={isMobile ? toggled : false}
        onToggle={(v) => setToggled(v)}
        breakPoint="sm"
        className="border-r border-gray-300 bg-white"
      >
        {isMobile && toggled && (
          <div className="flex justify-end pr-4 pt-2">
            <button
              onClick={() => setToggled(false)}
              className="text-xl font-bold text-gray-600"
              aria-label="Close sidebar"
            >
              ✖
            </button>
          </div>
        )}

        <div className={`flex justify-center py-6 ${collapsed && "hidden"}`}>
          <img src={logo} alt="Company Logo" className="w-24 h-auto" />
        </div>

        {/* MOBILE-ONLY typography & alignment:
            - Titles (menu-label) are bigger + bolder than any data (menu-data)
            - Larger icons & row height for comfortable tap targets
            Desktop/tablet (sm:) reverts to original sizes */}
        <div
          className="
            [&_.ps-menu-button]:py-3 sm:[&_.ps-menu-button]:py-2
            [&_.menu-icon_svg]:text-lg sm:[&_.menu-icon_svg]:text-base

            /* Title vs Data hierarchy */
            [&_.menu-label]:text-[17px] [&_.menu-label]:font-semibold
            sm:[&_.menu-label]:text-sm sm:[&_.menu-label]:font-normal

            [&_.menu-data]:text-xs [&_.menu-data]:font-medium [&_.menu-data]:opacity-80
            sm:[&_.menu-data]:text-xs
          "
        >
          <Menu iconShape="circle">
            <MenuItem
              icon={<FaChartLine className="menu-icon_svg" />}
              onClick={() => handleMenuClick("Home")}
              active={currentPage === "Home"}
            >
              <div className="flex items-center w-full">
                <span className="menu-label">Home</span>
                {/* optional right-side data: <span className="menu-data ml-auto">12</span> */}
              </div>
            </MenuItem>

            <MenuItem
              icon={<FaHistory className="menu-icon_svg" />}
              onClick={() => setCurrentPage("Product History")}
            >
              <div className="flex items-center w-full">
                <span className="menu-label">Product History</span>
                {/* <span className="menu-data ml-auto">—</span> */}
              </div>
            </MenuItem>

            <MenuItem
              icon={<FaPlus className="menu-icon_svg" />}
              onClick={() => setCurrentPage("Add Product")}
            >
              <div className="flex items-center w-full">
                <span className="menu-label">Add Product</span>
              </div>
            </MenuItem>

            <MenuItem
              icon={<FaReceipt className="menu-icon_svg" />}
              onClick={() => setCurrentPage("Billing History")}
            >
              <div className="flex items-center w-full">
                <span className="menu-label">Billing History</span>
              </div>
            </MenuItem>

            <MenuItem
              icon={<FaExchangeAlt className="menu-icon_svg" />}
              onClick={() => setCurrentPage("Transactions")}
            >
              <div className="flex items-center w-full">
                <span className="menu-label">Transactions</span>
              </div>
            </MenuItem>

            <MenuItem
              icon={<FaShoppingCart className="menu-icon_svg" />}
              onClick={() => setCurrentPage("Sale by Seller")}
            >
              <div className="flex items-center w-full">
                <span className="menu-label">Sale by Seller</span>
              </div>
            </MenuItem>

            <MenuItem
              icon={<FaShoppingCart className="menu-icon_svg" />}
              onClick={() => setCurrentPage("Saved Products")}
            >
              <div className="flex items-center w-full">
                <span className="menu-label">Saved Products</span>
              </div>
            </MenuItem>

            <MenuItem
              icon={<FaClipboardList className="menu-icon_svg" />}
              onClick={() => setCurrentPage("Order")}
            >
              <div className="flex items-center w-full">
                <span className="menu-label">Order</span>
              </div>
            </MenuItem>

            <MenuItem
              icon={<FaSignOutAlt className="menu-icon_svg" />}
              onClick={handleSignOut}
              className="mt-6"
            >
              <div className="flex items-center w-full">
                <span className="menu-label font-semibold">Sign Out</span>
              </div>
            </MenuItem>
          </Menu>
        </div>
      </ProSidebar>
    </div>
  );
};

export default Sidebar;
